import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-file-settings',
  templateUrl: './file-settings.component.html',
  styleUrls: ['./file-settings.component.scss']
})
export class FileSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
